import * as RadixTabs from '@radix-ui/react-tabs'
import { type ReactNode } from 'react'
import { cn } from './cn'

type TabItem = { value: string; label: ReactNode; content: ReactNode; disabled?: boolean }

export function Tabs({
  items,
  value,
  onValueChange,
  defaultValue,
  className,
}: {
  items: TabItem[]
  value?: string
  onValueChange?: (v: string) => void
  defaultValue?: string
  className?: string
}) {
  return (
    <RadixTabs.Root
      value={value}
      onValueChange={onValueChange}
      defaultValue={defaultValue ?? items[0]?.value}
      className={className}
    >
      <RadixTabs.List className="inline-flex border-b border-border gap-1">
        {items.map(item => (
          <RadixTabs.Trigger
            key={item.value}
            value={item.value}
            disabled={item.disabled}
            className={cn(
              'px-3 py-2 text-sm font-medium text-fg-subtle border-b-2 border-transparent -mb-px',
              'hover:text-fg',
              'data-[state=active]:text-fg data-[state=active]:border-accent',
              'disabled:opacity-50 disabled:cursor-not-allowed',
            )}
          >
            {item.label}
          </RadixTabs.Trigger>
        ))}
      </RadixTabs.List>
      {items.map(item => (
        <RadixTabs.Content key={item.value} value={item.value} className="pt-4 focus:outline-none">
          {item.content}
        </RadixTabs.Content>
      ))}
    </RadixTabs.Root>
  )
}
